// extracted by mini-css-extract-plugin
export default {"policy-table":"H2z3mCzIoR4ZsGjrZzaW"};